import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SpeedDial } from 'primereact/speeddial';
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import InputTextCNPJ from "../../../Componentes/InputTextCNPJ"; // Verifique se o caminho está correto
import InputTextCPF from "../../../Componentes/InputTextCPF";
import InputCEP from "../../../Componentes/InputTextCEP";
import InputTextTelefone from "../../../Componentes/InputTextTelefone";
import InputTextEmail from "../../../Componentes/InputTextEmail";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import Conexao from "../../../providers/Conexao";
import md5 from "md5";

export default function ModalAlterarSenha(props) {
    const [visible, setVisible] = useState(false);
    const [errors, setErrors] = useState(false);
    const [senha, setSenha] = useState('')
    const [confirmacaoSenha, setConfirmacaoSenha] = useState('')
    const toast = React.useRef(null); // Ref para o Toast
   

    useEffect(()=>{
        setErrors(false)
    }, [visible])




    const insertEmpresa = () =>{
        if(!props.revenda.idusuario){
            return;
        }
        setErrors(false)

       

        if(senha === ''){

            setErrors(true);

        }else if(senha !== confirmacaoSenha){

            setErrors(true)

        }

        if(errors){

            props.showMessage('danger',  'Preencha todos os campos obrigatórios');
            return

        }

        

    
        Conexao.post('empresasController/updateSenhaRevenda', {
            idusuario: props.revenda.idusuario, 
            senha : md5(senha)

        }).then(response =>{
            if(response.status == 200 && response.data.status === 'OK'){
                props.showMessage('success', 'Senha altarada com sucesso!')
            }else{
                props.showMessage('warn', 'Não foi possível altetar senha')
            }
            setVisible(false)
        }).catch(error => {
            props.showMessage('danger', 'Não foi possível altetar senha')
            setVisible(false)
        })
    }


    

      


      return (
            <div >
              
               

                 <Button 
                    onClick={() => {              
                        setVisible(true)
                    }}
  
                    icon="pi pi-user-edit" 
                    className= "p-button-primary p-button-sm" 
                    tooltip="Inserir um novo cliente" tooltipOptions={{ position: 'bottom' }}
                /> 
               
                
                <Dialog
                    header="Alterar Senha de Acesso (Revenda)"
                    visible={visible}                    
                    blockScroll={false} 
                    style={{ width: '40vw', }} // Largura padrão
                    breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                    onHide={() => setVisible(false)}
                >
                    {/* Opção de Pessoa Jurídica ou Física */}
                    
                    <div className="grid mt-2"  style={{padding : '20px', paddingTop : '0px'}}>
                         <div className="col-12 md:col-4">
                            <label htmlFor="documento" style={{fontWeight : 'bold'}}>CNPJ*</label>
                               <InputTextCNPJ
                                    value = {props.revenda.cpf_cnpj}
                                    name="cpf_cnpj"
                                    className="w-full mt-2"        
                                />                                 
                            </div>
                        
                        <div className="col-12 md:col-8">
                            <label htmlFor="razaoSocial" style={{fontWeight : 'bold'}}>Razão Social*</label>
                       
                            <InputText
                                value={props.revenda.nome}
                                name="razaosocial"
                                className="w-full mt-2"
                            />
                               
                        </div>
                                                       

                            <div className="col-12 md:col-6">
                                <label htmlFor="email" style={{fontWeight : 'bold'}}>Senha*</label>
                                <>
                                <InputText
                                    value={senha}
                                    onChange={(e)=>setSenha(e.target.value)}
                                    name="email"
                                    type="password"
                                    className="w-full mt-2"
                                />
                                    {errors && senha === '' ? <small className="p-error">Informe a Senha</small> : null}
                                    </>
                            </div>

                            <div className="col-12 md:col-6">
                                <label htmlFor="email" >Confirmação</label>
                                <>
                                <InputText
                                    value={confirmacaoSenha}
                                    onChange={(e)=>setConfirmacaoSenha(e.target.value)}
                                    name="confirmacaoSenha"
                                    type="password"
                                    className="w-full mt-2"
                                />
                                    {errors && senha !== confirmacaoSenha ? <small className="p-error">Senha e Confirmação de senha não são iguais</small> : null}
                                    </>
                            </div>

                    </div>
                     <div className="mt-4 flex justify-content-end mt-2">
                            <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                                    confirmDialog({
                                    message: 'Deseja cancelar?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {setVisible(false)}
                                });
                            }} />
                            <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                                   
                                    confirmDialog({
                                    message: 'Confirma a inclusão desse novo Cliente?',
                                    header: 'Confirmação',
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptLabel: 'Sim',
                                    rejectLabel: 'Não',
                                    accept: () => {
                                        insertEmpresa()
                                    } 
                                });
                            }} />
                        </div>
                </Dialog>
                <Toast ref={toast} />
            </div>
      )
    }